import React, { useState } from "react";
import "../styles/TabComponent.css";

const TabComponent = ({ title, description, tabs, onTabChange }) => { // Add `onTabChange` here
  const [active, setActive] = useState(tabs[0]?.key || "");
  
  return (
    <div className="rounded mb-3 mt-0 ">
      <h1 className="h4 mb-2">{title}</h1>
      <p>{description}</p>
      <div className="btn-group mb-1" role="group">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            type="button"
            className={`btn ${
              active === tab.key ? "btn-selected" : "btn-unselected"
            }`}
            onClick={() => {
              setActive(tab.key); // Update local state
              onTabChange(tab.key); // Notify parent component
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
};
export default TabComponent;



